module.exports = __webpack_public_path__ + "img/decor button diameter.ec8b24e3.png";